<div id="build-your-community-part-two-overlay" class="left-overlay bgc-glass" [ngStyle]="overlayStyles">
  <p class="larger-font"
    >And get rewarded for your Genesys advocacy with the
    <ng-container *ngTemplateOutlet="advocacyProgramLink"></ng-container>!
  </p>
</div>
<ng-template #advocacyProgramLink>
  <a
    class="overlay-link"
    (click)="onLinkClick()"
    href="https://orchestrators.genesys.com/advocacy?product=genesys-cloud-cx"
    target="_blank"
    title="Genesys Advocacy Program link"
    >Advocacy program</a
  >
</ng-template>
